module.exports = __webpack_public_path__ + "img/1524212697.82c327d9.jpg";